angular.module('assets')
    .component('assetBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<?'
        },
        templateUrl: 'app/asset/btn-options.html',
        controller: function ($rootScope, AssetService, FilesSimpleUploadService, FilesLibrary, AssetSettingsLoader) {
            this.AssetService = AssetService;

            this.fileResourceName = 'ASSET'

            this.$onChanges = () => {
                AssetSettingsLoader.isSupervisor().then(result => this.isSupervisor = result);
            }

            this.attachFile = () => FilesSimpleUploadService.open({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast('asset.updated'));
            this.attachLibraryFile = () => FilesLibrary.openAndBind({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast('asset.updated'));
        }
    })
